<script>
    import { SendRequest } from "./APIService";
    import { showModal } from "./Modal";

    let chatBanned = false;
    let userIdToBan = "";
    let bannedUsers = [];

    const reloadChatStatus = () => {
        SendRequest("IsChatBanned", "POST", "", (data) => {
            chatBanned = data === true;
        });
    };

    const toggleChatBan = () => {
        if (chatBanned) {
            SendRequest("UnBanChat", "POST", "", () => {
                chatBanned = false;
                showModal("UnBan Chat", "Chat is now unbanned", "OK");
            });
        } else {
            SendRequest("BanChat", "POST", "", () => {
                chatBanned = true;
                showModal("Ban Chat", "Chat is now banned", "OK");
            });
        }
    };

    const banUser = () => {
        if (!userIdToBan) {
            showModal("Error", "Please enter a User ID", "OK");
            return;
        }
        SendRequest("BanUserChat", "POST", "userId=" + userIdToBan, () => {
            showModal("Ban User", `${userIdToBan} is now banned`, "OK");
            userIdToBan = "";
            loadBannedUsers();
        });
    };

    const unbanUser = (id) => {
        SendRequest("UnBanUserChat", "POST", "userId=" + id, () => {
            showModal("UnBan User", `${id} is now unbanned`, "OK");
            loadBannedUsers();
        });
    };

    const loadBannedUsers = () => {
        SendRequest("GetAllChatBannedUsers", "GET", "", (data) => {
            bannedUsers = data;
        });
    };

    // Load initial data
    reloadChatStatus();
    loadBannedUsers();
</script>

<div class="card">
    <div class="card-header">
        <h3>Chat Control</h3>
    </div>
    <div class="card-body">
        <p>Status: {chatBanned ? "Banned" : "Active"}</p>
        <button class="btn {chatBanned ? 'btn-warning' : 'btn-danger'}" on:click={toggleChatBan}>
            {chatBanned ? "UnBan Chat" : "Ban Chat"}
        </button>
    </div>
</div>

<div class="card mt-3">
    <div class="card-header">
        <h3>Ban User Chat</h3>
    </div>
    <div class="card-body">
        <input type="text" placeholder="User ID" bind:value={userIdToBan} class="form-control mb-2"/>
        <button class="btn btn-danger" on:click={banUser}>Ban User</button>
    </div>
</div>

<div class="card mt-3">
    <div class="card-header">
        <h3>Banned Users</h3>
    </div>
    <div class="card-body">
        {#if bannedUsers.length > 0}
            <ul class="list-group">
                {#each bannedUsers as user (user.userId)}
                    <li class="list-group-item d-flex justify-content-between align-items-center">
                        {user.userId}
                        <button class="btn btn-sm btn-warning" on:click={() => unbanUser(user.userId)}>UnBan</button>
                    </li>
                {/each}
            </ul>
        {:else}
            <p>No users banned.</p>
        {/if}
    </div>
</div>

<style>
    .card {
        margin: 10px 0;
        padding: 10px;
    }
    .mt-3 {
        margin-top: 15px;
    }
</style>
